export default {
    airlinelist: [
        'TK',
        'Amadeus_Logo','ark','bookingagora','iatilogo','Galileo','Sabre','biletbanklogo','biletalllogo','DHL',
        '0A','0B','0D',
        '2J','2K', '2L','2M','2N','2P','2Q','2W','2Y','3B',
        '3C','3I','3K','3L','3M','3R','3S','3W','3Y',
        '4D','4J','4L','4M','4R', '4T','4U',
        '5G', '5J','5L','5N','5R','5T','5V','5W','5Y','5Z ',
        '6A','6H','6N','6S','6V',
        '7B', '7D', '7E', '7F', '7I', '7J', '7K', '7W',
        '8A', '8G', '8J', '8M', '8N', '8O', '8P', '8U', '8W','8Q',
        '9B', '9D', '9F', '9H', '9K', '9M', '9U', '9W', '9X', '9Y',
        'A3', 'A5', 'A6', 'A7', 'A8', 'A9', 'AA', 'AB', 'AC', 'AE','AF','AI','AJ','AK','AM','ANJ','AP','AQ','AR','AS','AT','AU','AV','AX','AY','AZ',
        'B2','B3','B5','B6','B8','BA','BD','BE','BG','BH','BI','BJ','BL','BP','BR','BRJ','BT','BU','BV','BW','BX',
        'C4','C9','CA','CAI','CB','CC','CE','CF','CG','CI','CL','CM','CND','CO','CU','CW','CX','CY','CZ',
        'D2','D3','D5','D6','D7','D9','DC','DE','DI','DJ','DL','DN','DO','DR','DT','DU','DV','DX','DY',
        'E0','E3','E5','E7','EA','EE','EF','EG','EI','EK','EL','EN','EO','ET','EY',
        'F9','FB','FC','FD','FG','FHE','FHY','FI','FJ','FL','FM','FN','FPO','FQ','FT','FV','FZ',
        'G0','G3','G9','GA','GE','GF','GHY','GI','GJ','GL','GQ','GR','GT','GU','GW','GY',
        'H2','H3','H4','H5','H8','H9','HA','HE','HF','HG','HM','HR','HS','HU','HV','HX','HY','HZ',
        'I2','I5','I7','I9','IB','IC','IE','IF','IG','IH','IK','IN','IP','IQ','IR','IT','IZ',
        'J0','J2','J3','J4','J7','J8','JA','JB','JJ','JK','JL','JM','JN','JO','JP','JQ','JU','JV','JX','JZ',
        'K6','K8','KA','KC','KD','KE','KF','KHO','KJ','KK','KL','KM','KQ','KS','KU','KV','KX',
        'L3','L5','L6','LA','LF','LG','LH','LI','LM','LN','LO','LP','LR','LT','LU','LV','LW','LX','LY',
        'M3','M5','M9','MA','MD','ME','MF','MH','MI','Mixed','MK','MN','MO','MP','MS','MU','MX','MY',
        'N2','N3','N7','NA','NC','NF','NG','NH','NK','NN','NT','NW','NX','NZ',
        'O4','O7','OA','OG','OHY','OK','OL','OM','ON','ONX','OP','OR','ORB','OS','OT','OU','OV','OY','OZ',
        'P8','P9','PC','PG','PJ','PR','PS','PU','PW','PX','PY','PZ',
        'Q8','QB','QC','QF','QH','QI','QM','QR','QS','QV','QZ',
        'R2','R3','R4','R6','R7','RA','RB','RC','RE','RG','RJ','RO','RT','RU','RV','RQ',
        'S0','S2','S3','S4','S5','S7','SA','SB','SD','SE','SK','SKY','SN','SP','SQ','SS','ST','SU','SV','SW','SY',
        'T3','T6','T7','TA','TC','TD','TE','TF','TG','THY','TK','TL','TM','TN','TO','TP','TS','TU','TWI','TX','TZ',
        'U4','U5','U6','U7','U8','U9','UD','UF','UG','UH','UL','UM','UN','UO','UP','US','UT','UU','UV','UY',
        'V0','V3','V7','VA','VF','VG','VH','VK','VM','VN','VO','VR','VS','VT','VU','VV','VW','VY',
        'W3','W5','W7','W9','WA','WB','WF','WK','WM','WR','WS','WX','WY','WZ',
        'X3','X7','X9','XC','XE','XF','XG','XK','XL','XLA','XM','XP','XQ','XR','XY',
        'Y0','Y7','YB','YD','YG','YK','YM','YO','YQ','YR','YS','YV','YX',
        'Z5','Z6','ZA','ZB','ZE','ZH','ZI','ZK','ZL','ZV','ZY','LL','FK','ajet_logo','W6','LS'
    ],

    logoControl(img) {
        var sira = this.airlinelist.indexOf(img);
        if (sira != -1) {
            var images = require.context('./airlinelogo', false, /\.png$/)
            var url = images('./' + img + ".png");
            return images('./' + img + ".png")
        } else {
            var images = require.context('./airlinelogo', false, /\.png$/)
            var url = images('./' + 'default' + ".png");
            return images('./' + "default" + ".png")
        }
    }
}